import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Title3 } from '@sorare/core/src/atoms/typography';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { LEGACY_PLAYER_SHOW } from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { scarcityMessages } from '@sorare/core/src/lib/scarcity';

type Props = {
  player: {
    slug: string;
    displayName: string;
  };
  rarity: Rarity;
  sport: Sport;
};

export const SecondaryMarketStackedTitle = styled(Title3)`
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &,
  & a {
    color: var(--c-neutral-1000);
  }

  & span {
    margin-left: var(--unit);
    color: var(--c-neutral-600);
  }
`;

export const MarketStackTitle = ({ player, rarity, sport }: Props) => {
  const { generateSportContextPath } = useSportContext();
  const playerUrl = generateSportContextPath(LEGACY_PLAYER_SHOW, {
    params: { slug: player.slug },
    sport,
  });

  return (
    <PageHeader
      customTitle={
        <SecondaryMarketStackedTitle>
          <Link to={playerUrl}>{player.displayName}</Link>
          <span>
            <FormattedMessage {...scarcityMessages[rarity]} />
          </span>
        </SecondaryMarketStackedTitle>
      }
    />
  );
};
